<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户id" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户id" />
      </a-form-model-item>
      <a-form-model-item label="入睡时间" prop="startTime" >
        <a-date-picker style="width: 100%" v-model="form.startTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="清醒时间" prop="endTime" >
        <a-date-picker style="width: 100%" v-model="form.endTime" format="YYYY-MM-DD HH:mm:ss" allow-clear/>
      </a-form-model-item>
      <a-form-model-item label="睡眠总时长(min)" prop="sleepTotalTime" >
        <a-input v-model="form.sleepTotalTime" placeholder="请输入睡眠总时长(min)" />
      </a-form-model-item>
      <a-form-model-item label="零星睡眠时长(min)" prop="scatteredTime" >
        <a-input v-model="form.scatteredTime" placeholder="请输入零星睡眠时长(min)" />
      </a-form-model-item>
      <a-form-model-item label="深度睡眠时长(min)" prop="depthSleepTime" >
        <a-input v-model="form.depthSleepTime" placeholder="请输入深度睡眠时长(min)" />
      </a-form-model-item>
      <a-form-model-item label="浅度睡眠时长(min)" prop="shallowSleepTime" >
        <a-input v-model="form.shallowSleepTime" placeholder="请输入浅度睡眠时长(min)" />
      </a-form-model-item>
      <a-form-model-item label="快速眼动时长(min)" prop="eyeMovementTime" >
        <a-input v-model="form.eyeMovementTime" placeholder="请输入快速眼动时长(min)" />
      </a-form-model-item>
      <a-form-model-item label="苏醒时长(min)" prop="awakeningTime" >
        <a-input v-model="form.awakeningTime" placeholder="请输入苏醒时长(min)" />
      </a-form-model-item>
      <a-form-model-item label="准备时长(min)" prop="prepareTime" >
        <a-input v-model="form.prepareTime" placeholder="请输入准备时长(min)" />
      </a-form-model-item>
      <a-form-model-item label="苏醒次数" prop="awakeningNum" >
        <a-input v-model="form.awakeningNum" placeholder="请输入苏醒次数" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSleep, addSleep, updateSleep } from '@/api/joe/sleep'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        startTime: null,

        endTime: null,

        sleepTotalTime: null,

        scatteredTime: null,

        depthSleepTime: null,

        shallowSleepTime: null,

        eyeMovementTime: null,

        awakeningTime: null,

        prepareTime: null,

        awakeningNum: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        startTime: null,
        endTime: null,
        sleepTotalTime: null,
        scatteredTime: null,
        depthSleepTime: null,
        shallowSleepTime: null,
        eyeMovementTime: null,
        awakeningTime: null,
        prepareTime: null,
        awakeningNum: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSleep({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateSleep(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addSleep(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
